'use strict';

import jQuery from 'jquery';

var Card = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      },
      swipeDistance: 0,
      SWIPE_THRESHOLD: 10
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function init() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create a reference to the cards
      privateNS.$cards = privateNS.$container.find('.cards .card');

      // Attach event handlers
      privateNS.attachHandlers();

      // Return the public namespace
      return publicNS;
    };

    /**
     * Attach the event handlers
     */
    privateNS.attachHandlers = function attachHandlers() {
      privateNS.$cards.on('mouseover',
        function() {
          $(this).addClass('active');
        }
      );

      privateNS.$cards.on(
        'mouseout',
        function() {
          $(this).removeClass('active');
        }
      );

      privateNS.$cards.on('touchstart', function() {
        privateNS.startSwipe = window.scrollY;
      });

      privateNS.$cards.on('touchend', function(e) {
        if (Math.abs(window.scrollY - privateNS.startSwipe) < privateNS.SWIPE_THRESHOLD) {
          var $btn = $(this).find('a');

          if ($btn.length > 0) {
            location.href = $btn.attr('href');
          }

          // Don't want the mouseover to be triggered.  Otherwise when using back the hover state is on.
          e.preventDefault();
        }
      });
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default Card